import { safePattern } from "@proof/core";
export const matchOptions = [
  ["eq", "is"],
  ["startsWith", "starts with"],
  ["endsWith", "ends with"],
  ["contains", "contains"],
  ["matches", "custom regex"],
] as const;
export type MatchOp = (typeof matchOptions)[number][0];
export function MatchOperator({
  value,
  onChange,
  label = "Match operator",
}: {
  value?: MatchOp;
  onChange: (value: MatchOp) => void;
  label?: string;
}) {
  return (
    <select
      aria-label={label}
      value={value || "eq"}
      onChange={(e) => onChange(e.target.value as MatchOp)}
    >
      {matchOptions.map(([key, text]) => (
        <option key={key} value={key}>
          {text}
        </option>
      ))}
    </select>
  );
}
export function PatternHelp({ op, value }: { op?: string; value: unknown }) {
  if (op !== "matches") return null;
  let error = "";
  try {
    safePattern(String(value ?? ""));
  } catch (e) {
    error = e instanceof Error ? e.message : "Invalid regex";
  }
  return (
    <p className="muted" role={error ? "alert" : undefined}>
      {error ||
        "Case-sensitive regex, without / delimiters. Maximum 256 characters; unsafe constructs are rejected."}
    </p>
  );
}
